export const CurrentWeekInspection = ({ color }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_35836_152242)">
        <path
          d="M5.03125 0C5.22187 0 5.40469 0.0757252 5.53948 0.210517C5.67427 0.345309 5.75 0.528126 5.75 0.71875V1.4375H17.25V0.71875C17.25 0.528126 17.3257 0.345309 17.4605 0.210517C17.5953 0.0757252 17.7781 0 17.9688 0C18.1594 0 18.3422 0.0757252 18.477 0.210517C18.6118 0.345309 18.6875 0.528126 18.6875 0.71875V1.4375H20.125C20.8875 1.4375 21.6188 1.7404 22.1579 2.27957C22.6971 2.81874 23 3.55 23 4.3125V20.125C23 20.8875 22.6971 21.6188 22.1579 22.1579C21.6188 22.6971 20.8875 23 20.125 23H2.875C2.1125 23 1.38124 22.6971 0.842068 22.1579C0.302901 21.6188 0 20.8875 0 20.125V4.3125C0 3.55 0.302901 2.81874 0.842068 2.27957C1.38124 1.7404 2.1125 1.4375 2.875 1.4375H4.3125V0.71875C4.3125 0.528126 4.38823 0.345309 4.52302 0.210517C4.65781 0.0757252 4.84063 0 5.03125 0ZM2.875 2.875C2.49375 2.875 2.12812 3.02645 1.85853 3.29603C1.58895 3.56562 1.4375 3.93125 1.4375 4.3125V20.125C1.4375 20.5062 1.58895 20.8719 1.85853 21.1415C2.12812 21.411 2.49375 21.5625 2.875 21.5625H20.125C20.5062 21.5625 20.8719 21.411 21.1415 21.1415C21.411 20.8719 21.5625 20.5062 21.5625 20.125V4.3125C21.5625 3.93125 21.411 3.56562 21.1415 3.29603C20.8719 3.02645 20.5062 2.875 20.125 2.875H2.875Z"
          fill={color}
        />
        <path
          d="M3.59375 5.75C3.59375 5.55938 3.66948 5.37656 3.80427 5.24177C3.93906 5.10698 4.12188 5.03125 4.3125 5.03125H18.6875C18.8781 5.03125 19.0609 5.10698 19.1957 5.24177C19.3305 5.37656 19.4062 5.55938 19.4062 5.75V7.1875C19.4062 7.37812 19.3305 7.56094 19.1957 7.69573C19.0609 7.83052 18.8781 7.90625 18.6875 7.90625H4.3125C4.12188 7.90625 3.93906 7.83052 3.80427 7.69573C3.66948 7.56094 3.59375 7.37812 3.59375 7.1875V5.75ZM15.8125 10.7812C15.8125 10.5906 15.8882 10.4078 16.023 10.273C16.1578 10.1382 16.3406 10.0625 16.5312 10.0625H17.9688C18.1594 10.0625 18.3422 10.1382 18.477 10.273C18.6118 10.4078 18.6875 10.5906 18.6875 10.7812V12.2188C18.6875 12.4094 18.6118 12.5922 18.477 12.727C18.3422 12.8618 18.1594 12.9375 17.9688 12.9375H16.5312C16.3406 12.9375 16.1578 12.8618 16.023 12.727C15.8882 12.5922 15.8125 12.4094 15.8125 12.2188V10.7812ZM11.5 10.7812C11.5 10.5906 11.5757 10.4078 11.7105 10.273C11.8453 10.1382 12.0281 10.0625 12.2188 10.0625H13.6562C13.8469 10.0625 14.0297 10.1382 14.1645 10.273C14.2993 10.4078 14.375 10.5906 14.375 10.7812V12.2188C14.375 12.4094 14.2993 12.5922 14.1645 12.727C14.0297 12.8618 13.8469 12.9375 13.6562 12.9375H12.2188C12.0281 12.9375 11.8453 12.8618 11.7105 12.727C11.5757 12.5922 11.5 12.4094 11.5 12.2188V10.7812ZM4.3125 15.0938C4.3125 14.9031 4.38823 14.7203 4.52302 14.5855C4.65781 14.4507 4.84063 14.375 5.03125 14.375H6.46875C6.65937 14.375 6.84219 14.4507 6.97698 14.5855C7.11177 14.7203 7.1875 14.9031 7.1875 15.0938V16.5312C7.1875 16.7219 7.11177 16.9047 6.97698 17.0395C6.84219 17.1743 6.65937 17.25 6.46875 17.25H5.03125C4.84063 17.25 4.65781 17.1743 4.52302 17.0395C4.38823 16.9047 4.3125 16.7219 4.3125 16.5312V15.0938ZM8.625 15.0938C8.625 14.9031 8.70073 14.7203 8.83552 14.5855C8.97031 14.4507 9.15313 14.375 9.34375 14.375H10.7812C10.9719 14.375 11.1547 14.4507 11.2895 14.5855C11.4243 14.7203 11.5 14.9031 11.5 15.0938V16.5312C11.5 16.7219 11.4243 16.9047 11.2895 17.0395C11.1547 17.1743 10.9719 17.25 10.7812 17.25H9.34375C9.15313 17.25 8.97031 17.1743 8.83552 17.0395C8.70073 16.9047 8.625 16.7219 8.625 16.5312V15.0938Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_35836_152242">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <g id="Menu / Close_MD">
          {' '}
          <path
            id="Vector"
            d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
            stroke="#666666"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>{' '}
        </g>{' '}
      </g>
    </svg>
  );
};
export const ConvergeIcon = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_35836_152305)">
        <path
          d="M3.58073 13.0827H9.91406M9.91406 13.0827V19.416M9.91406 13.0827L2.78906 20.2077M20.2057 2.79102L13.0807 9.91602M13.0807 9.91602H19.4141M13.0807 9.91602V3.58268"
          stroke="#666666"
          stroke-width="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_35836_152305">
          <rect
            width="19"
            height="19"
            fill="white"
            transform="translate(1 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TotalInspectionCount = ({ color }) => {
  return (
    <svg
      width="25px"
      height="25px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#000000"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M11 7L8 17"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
        <path
          d="M16 7L13 17"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
        <path
          d="M18 10H7"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
        <path
          d="M17 14H6"
          stroke={color}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
        <path
          opacity="1"
          d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
          stroke={color}
          stroke-width="1.5"
        ></path>{' '}
      </g>
    </svg>
  );
};

export const InspectionOverview = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.3932 17.1882V9.89648H2.60156V21.3548C2.60156 21.9301 3.06793 22.3965 3.64323 22.3965H12.4974"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.60156 5.20768C2.60156 4.63239 3.06793 4.16602 3.64323 4.16602H21.3516C21.9269 4.16602 22.3932 4.63239 22.3932 5.20768V9.89518H2.60156V5.20768Z"
        stroke={color}
        stroke-width="2"
        stroke-linejoin="round"
      />
      <path
        d="M8.33594 2.60352V6.77018"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M16.6641 2.60352V6.77018"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M15.6224 20.3132C17.6359 20.3132 19.2682 18.6809 19.2682 16.6673C19.2682 14.6538 17.6359 13.0215 15.6224 13.0215C13.6089 13.0215 11.9766 14.6538 11.9766 16.6673C11.9766 18.6809 13.6089 20.3132 15.6224 20.3132Z"
        stroke={color}
        stroke-width="2"
      />
      <path
        d="M18.75 19.2715L21.875 21.8757"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ConversationStatistics = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8307 11.9798V7.29232L16.1432 2.08398H5.20573C4.63043 2.08398 4.16406 2.55035 4.16406 3.12565V21.8757C4.16406 22.451 4.63043 22.9173 5.20573 22.9173H11.4557"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0625 17.1875H21.3542"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0625 20.3125H21.3542"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3542 17.1882L18.75 14.584"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.6667 22.9167L14.0625 20.3125"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.625 2.08398V7.29232H20.8333"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DemographicMap = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.98725 11.6266C6.641 10.9191 6.458 10.1246 6.458 9.32859C6.458 8.89284 6.521 8.44509 6.65 7.96159C6.70775 7.74409 6.78025 7.53609 6.86175 7.33434C6.549 7.16359 6.20525 7.05859 5.8365 7.05859C4.469 7.05859 3.362 8.34684 3.362 9.93784C3.362 11.0508 3.906 12.0141 4.7005 12.4933L1.34675 14.0543C1.13775 14.1526 1 14.3886 1 14.6523V17.2993C1 17.6541 1.24775 17.9416 1.5525 17.9416H3.53475V15.1641C3.53475 14.3548 3.98525 13.6211 4.6845 13.2938L7.25 12.0991C7.155 11.9481 7.06725 11.7903 6.98725 11.6266Z"
        fill={color}
      />
      <path
        d="M15.0323 8.70019H23.5552C23.5557 8.70019 23.5563 8.70019 23.5568 8.70019C23.8 8.70019 23.997 8.50294 23.997 8.25994V6.65219C23.997 6.40894 23.7998 6.21194 23.5568 6.21194C23.5563 6.21194 23.5557 6.21219 23.5552 6.21219V6.21094H14.0312C14.4347 6.73944 14.7423 7.36769 14.9128 8.06969C14.9665 8.29194 15.0055 8.49969 15.0323 8.70019Z"
        fill={color}
      />
      <path
        d="M24.0007 16.6112C24.0007 16.3679 23.8034 16.1709 23.5604 16.1709C23.5599 16.1709 23.5594 16.1712 23.5589 16.1712V16.1699H18.0034V17.9437V18.4422C18.0034 18.5154 17.9994 18.5877 17.9922 18.6589H23.5589C23.5594 18.6589 23.5599 18.6589 23.5604 18.6589C23.8037 18.6589 24.0007 18.4617 24.0007 18.2187V16.6112Z"
        fill={color}
      />
      <path
        d="M23.5541 11.1905C23.5536 11.1905 23.5531 11.1907 23.5526 11.1907V11.1895H14.7314C14.6916 11.2942 14.6496 11.3985 14.6029 11.5017C14.5119 11.7022 14.4096 11.894 14.2969 12.076L16.8689 13.303C17.0641 13.3975 17.2371 13.5272 17.3884 13.6787H23.5526C23.5531 13.6787 23.5536 13.6787 23.5541 13.6787C23.7974 13.6787 23.9944 13.4815 23.9944 13.2385V11.6307C23.9944 11.3875 23.7971 11.1905 23.5541 11.1905Z"
        fill={color}
      />
      <path
        d="M16.3295 14.4264L13.4417 13.0489L12.2205 12.4664C12.754 12.1304 13.187 11.6119 13.4705 10.9871C13.6953 10.4911 13.8293 9.92937 13.8293 9.32937C13.8293 8.99237 13.776 8.67263 13.7013 8.36363C13.338 6.86788 12.1698 5.76562 10.7673 5.76562C9.39125 5.76562 8.24075 6.82838 7.85525 8.28188C7.76625 8.61513 7.70475 8.96187 7.70475 9.32912C7.70475 9.96712 7.85375 10.5616 8.107 11.0791C8.39975 11.6791 8.8335 12.1739 9.3615 12.4919L8.192 13.0364L5.2105 14.4249C4.95125 14.5461 4.78125 14.8384 4.78125 15.1646V17.9424V18.4409C4.78125 18.8799 5.08725 19.2361 5.465 19.2361H16.0693C16.447 19.2361 16.753 18.8801 16.753 18.4409V17.9424V15.1649C16.7535 14.8396 16.586 14.5504 16.3295 14.4264Z"
        fill={color}
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.70865 1.5C4.72742 1.5 1.5 4.65614 1.5 8.54945C1.5 12.4427 4.72742 15.5989 8.70865 15.5989C10.4114 15.5989 11.9763 15.0216 13.2097 14.0561L15.5528 16.3415L15.6151 16.394C15.8327 16.5514 16.1411 16.5335 16.3379 16.3405C16.5544 16.1282 16.554 15.7845 16.3369 15.5727L14.0214 13.3142C15.1987 12.0595 15.9173 10.3866 15.9173 8.54945C15.9173 4.65614 12.6899 1.5 8.70865 1.5ZM8.70866 2.5858C12.0767 2.5858 14.807 5.25582 14.807 8.54945C14.807 11.8431 12.0767 14.5131 8.70866 14.5131C5.34064 14.5131 2.61033 11.8431 2.61033 8.54945C2.61033 5.25582 5.34064 2.5858 8.70866 2.5858Z"
        fill="#666666"
      />
    </svg>
  );
};

export const MarketOverview = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4141 7.29167H14.5807M1.5599 15.1042C1.5599 15.1042 5.72656 5.20833 6.2474 4.16667C6.76823 3.125 7.8099 3.125 8.33073 3.125C8.85156 3.125 10.4141 3.125 10.4141 5.20833V16.6667H14.5807V5.20833C14.5807 3.125 16.1432 3.125 16.6641 3.125C17.1849 3.125 18.2266 3.125 18.7474 4.16667C19.2682 5.20833 23.4349 15.1042 23.4349 15.1042M19.2682 21.875C21.8571 21.875 23.9557 19.7763 23.9557 17.1875C23.9557 14.5987 21.8571 12.5 19.2682 12.5C16.6794 12.5 14.5807 14.5987 14.5807 17.1875C14.5807 19.7763 16.6794 21.875 19.2682 21.875ZM5.72656 21.875C3.13773 21.875 1.03906 19.7763 1.03906 17.1875C1.03906 14.5987 3.13773 12.5 5.72656 12.5C8.3154 12.5 10.4141 14.5987 10.4141 17.1875C10.4141 19.7763 8.3154 21.875 5.72656 21.875Z"
        stroke={color}
        stroke-width="2"
      />
    </svg>
  );
};

export const NumberOfOffers = ({ color }) => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_35820_152215)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.04959 0.127229C8.22155 0.219298 8.36532 0.356297 8.46557 0.523629C8.56581 0.69096 8.61879 0.882354 8.61884 1.07742V7.93429H9.6409C9.92684 7.93429 10.2011 8.04788 10.4032 8.25007C10.6054 8.45225 10.719 8.72648 10.719 9.01242C10.719 9.29835 10.6054 9.57258 10.4032 9.77477C10.2011 9.97695 9.92684 10.0905 9.6409 10.0905H5.3974C5.11146 10.0905 4.83724 9.97695 4.63505 9.77477C4.43286 9.57258 4.31928 9.29835 4.31928 9.01242C4.31928 8.72648 4.43286 8.45225 4.63505 8.25007C4.83724 8.04788 5.11146 7.93429 5.3974 7.93429H6.46259V3.08992L5.98246 3.41048C5.74454 3.56534 5.45514 3.62012 5.17708 3.56291C4.89902 3.50571 4.65474 3.34114 4.49727 3.10494C4.3398 2.86873 4.28185 2.57995 4.33599 2.30128C4.39013 2.02261 4.552 1.77654 4.78646 1.61648L6.94271 0.178979C7.10512 0.070761 7.29386 0.00865667 7.48879 -0.000710357C7.68373 -0.0100774 7.87755 0.0336442 8.04959 0.125791V0.127229ZM12.9313 6.82742C12.9313 6.54148 13.0449 6.26725 13.2471 6.06507C13.4493 5.86288 13.7235 5.74929 14.0095 5.74929H19.7595C19.9726 5.74948 20.1808 5.81281 20.3579 5.93129C20.5351 6.04977 20.6731 6.21808 20.7546 6.41496C20.8361 6.61185 20.8575 6.82848 20.816 7.03749C20.7745 7.2465 20.6719 7.43852 20.5213 7.58929L17.8045 10.309C18.253 10.4183 18.6727 10.5678 19.0508 10.7676C20.1174 11.3297 20.839 12.2957 20.839 13.6498C20.839 14.5885 20.507 15.3863 19.9348 15.9886C19.38 16.5751 18.6497 16.9273 17.9108 17.1055C16.459 17.4549 14.7124 17.1961 13.4201 16.348C13.1898 16.1875 13.0312 15.9436 12.9779 15.6681C12.9246 15.3925 12.9809 15.1071 13.1347 14.8723C13.2886 14.6376 13.5279 14.4721 13.8019 14.4111C14.0758 14.35 14.3627 14.3982 14.6017 14.5454C15.3693 15.0485 16.4992 15.2267 17.4063 15.0082C17.8461 14.9033 18.1681 14.7193 18.3694 14.5065C18.5548 14.311 18.6828 14.0465 18.6828 13.6498C18.6828 13.207 18.506 12.9181 18.0445 12.6752C17.5083 12.392 16.6358 12.218 15.4484 12.218C15.2353 12.2179 15.027 12.1545 14.8499 12.036C14.6728 11.9176 14.5348 11.7493 14.4532 11.5524C14.3717 11.3555 14.3504 11.1389 14.3919 10.9298C14.4334 10.7208 14.5359 10.5288 14.6865 10.378L17.159 7.90554H14.0095C13.7235 7.90554 13.4493 7.79195 13.2471 7.58977C13.0449 7.38758 12.9313 7.11335 12.9313 6.82742ZM7.77503 15.1117C7.2719 15.0399 6.66815 15.2742 6.36196 15.934C6.30422 16.0653 6.22085 16.1838 6.11673 16.2825C6.01261 16.3812 5.88983 16.4582 5.7556 16.5088C5.62137 16.5595 5.47837 16.5828 5.335 16.5775C5.19163 16.5722 5.05076 16.5383 4.92065 16.4778C4.79054 16.4173 4.67381 16.3315 4.57729 16.2254C4.48078 16.1192 4.40642 15.9949 4.35858 15.8596C4.31074 15.7243 4.29038 15.5809 4.29868 15.4377C4.30699 15.2944 4.3438 15.1543 4.40696 15.0255C5.13721 13.4529 6.69115 12.7758 8.08409 12.977C9.52159 13.1855 10.7751 14.3355 10.7751 16.1712C10.7751 18.2311 9.21109 19.3222 8.20196 20.0251C7.75921 20.3356 7.38115 20.5958 7.09221 20.8488H10.0563C10.3423 20.8488 10.6165 20.9624 10.8187 21.1646C11.0209 21.3668 11.1345 21.641 11.1345 21.9269C11.1345 22.2129 11.0209 22.4871 10.8187 22.6893C10.6165 22.8915 10.3423 23.005 10.0563 23.005H5.38446C5.09853 23.005 4.8243 22.8915 4.62211 22.6893C4.41993 22.4871 4.30634 22.2129 4.30634 21.9269C4.30634 20.935 4.73759 20.1861 5.26946 19.6125C5.76971 19.0778 6.41946 18.6408 6.92259 18.29C8.07259 17.485 8.61884 16.9905 8.61884 16.1712C8.61884 15.4912 8.23503 15.1793 7.77503 15.1117Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_35820_152215">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OfferComparison = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_35820_152217)">
        <path
          d="M3.125 18.75H17.7083"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.375 9.375L12.5 12.5L9.375 15.625"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.5859 15.625L17.7109 18.75L14.5859 21.875"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.125 3.125V21.875"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.125 12.5H12.5"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.75 3.125L21.875 6.25L18.75 9.375"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.125 6.25H21.875"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_35820_152217">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OfferVsMarket = ({ color }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_35820_152226)">
        <path
          d="M10.4141 3.33452C8.78458 3.71227 7.28585 4.5191 6.0733 5.67132C4.86076 6.82355 3.97858 8.27921 3.51825 9.8873C3.05793 11.4954 3.03622 13.1974 3.4554 14.8167C3.87457 16.436 4.71936 17.9137 5.90212 19.0964C7.08489 20.2792 8.56257 21.124 10.1819 21.5432C11.8012 21.9623 13.5032 21.9406 15.1113 21.4803C16.7194 21.02 18.175 20.1378 19.3272 18.9253C20.4795 17.7127 21.2863 16.214 21.6641 14.5845C21.6641 14.3082 21.5543 14.0433 21.359 13.8479C21.1636 13.6526 20.8987 13.5428 20.6224 13.5428H16.6641C16.4747 14.271 16.0963 14.9362 15.5673 15.4711C15.0382 16.006 14.3773 16.3917 13.6513 16.5891C12.9253 16.7865 12.16 16.7886 11.4329 16.5952C10.7059 16.4018 10.0428 16.0198 9.51079 15.4878C8.9788 14.9558 8.59678 14.2927 8.4034 13.5656C8.21001 12.8386 8.21212 12.0733 8.40951 11.3473C8.60691 10.6213 8.99258 9.96035 9.52749 9.4313C10.0624 8.90225 10.7276 8.52389 11.4557 8.33452V4.16785C11.4428 4.04444 11.4055 3.92482 11.3459 3.81594C11.2864 3.70706 11.2059 3.61108 11.109 3.53356C11.0121 3.45604 10.9008 3.39853 10.7815 3.36437C10.6622 3.3302 10.5373 3.32005 10.4141 3.33452Z"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.625 3.64648C16.9476 4.1122 18.1489 4.86867 19.1405 5.86019C20.132 6.85171 20.8885 8.05302 21.3542 9.37565H16.6667C16.3473 9.00164 15.999 8.65335 15.625 8.33398V3.64648Z"
          stroke={color}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_35820_152226">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ExpandIcon = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.96875 1.4668H7.83542V2.93346H4.47251L9.08729 7.54826L8.05021 8.58534L3.43542 3.97056V7.33346H1.96875V1.4668ZM18.5317 2.93346H15.1687V1.4668H21.0354V7.33346H19.5687V3.97056L14.954 8.58534L13.9169 7.54826L18.5317 2.93346ZM9.08729 14.452L4.47251 19.0668H7.83542V20.5335H1.96875V14.6668H3.43542V18.0297L8.05021 13.4149L9.08729 14.452ZM14.954 13.4149L19.5687 18.0297V14.6668H21.0354V20.5335H15.1687V19.0668H18.5317L13.9169 14.452L14.954 13.4149Z"
        fill="#666666"
      />
    </svg>
  );
};

export const ChartFilter = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5231 3H2.04688L10.2374 12.46V19L14.3326 21V12.46L22.5231 3Z"
        stroke="#65676B"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5.0005C8.73478 5.0005 8.48043 5.10585 8.29289 5.29339C8.10536 5.48093 8 5.73528 8 6.0005C8 6.26571 8.10536 6.52007 8.29289 6.7076C8.48043 6.89514 8.73478 7.0005 9 7.0005C9.26522 7.0005 9.51957 6.89514 9.70711 6.7076C9.89464 6.52007 10 6.26571 10 6.0005C10 5.73528 9.89464 5.48093 9.70711 5.29339C9.51957 5.10585 9.26522 5.0005 9 5.0005ZM6.17 5.0005C6.3766 4.41496 6.75974 3.90793 7.2666 3.54929C7.77346 3.19064 8.37909 2.99805 9 2.99805C9.62091 2.99805 10.2265 3.19064 10.7334 3.54929C11.2403 3.90793 11.6234 4.41496 11.83 5.0005H19C19.2652 5.0005 19.5196 5.10585 19.7071 5.29339C19.8946 5.48093 20 5.73528 20 6.0005C20 6.26571 19.8946 6.52007 19.7071 6.7076C19.5196 6.89514 19.2652 7.0005 19 7.0005H11.83C11.6234 7.58603 11.2403 8.09306 10.7334 8.45171C10.2265 8.81035 9.62091 9.00295 9 9.00295C8.37909 9.00295 7.77346 8.81035 7.2666 8.45171C6.75974 8.09306 6.3766 7.58603 6.17 7.0005H5C4.73478 7.0005 4.48043 6.89514 4.29289 6.7076C4.10536 6.52007 4 6.26571 4 6.0005C4 5.73528 4.10536 5.48093 4.29289 5.29339C4.48043 5.10585 4.73478 5.0005 5 5.0005H6.17ZM15 11.0005C14.7348 11.0005 14.4804 11.1059 14.2929 11.2934C14.1054 11.4809 14 11.7353 14 12.0005C14 12.2657 14.1054 12.5201 14.2929 12.7076C14.4804 12.8951 14.7348 13.0005 15 13.0005C15.2652 13.0005 15.5196 12.8951 15.7071 12.7076C15.8946 12.5201 16 12.2657 16 12.0005C16 11.7353 15.8946 11.4809 15.7071 11.2934C15.5196 11.1059 15.2652 11.0005 15 11.0005ZM12.17 11.0005C12.3766 10.415 12.7597 9.90793 13.2666 9.54929C13.7735 9.19064 14.3791 8.99805 15 8.99805C15.6209 8.99805 16.2265 9.19064 16.7334 9.54929C17.2403 9.90793 17.6234 10.415 17.83 11.0005H19C19.2652 11.0005 19.5196 11.1059 19.7071 11.2934C19.8946 11.4809 20 11.7353 20 12.0005C20 12.2657 19.8946 12.5201 19.7071 12.7076C19.5196 12.8951 19.2652 13.0005 19 13.0005H17.83C17.6234 13.586 17.2403 14.0931 16.7334 14.4517C16.2265 14.8104 15.6209 15.0029 15 15.0029C14.3791 15.0029 13.7735 14.8104 13.2666 14.4517C12.7597 14.0931 12.3766 13.586 12.17 13.0005H5C4.73478 13.0005 4.48043 12.8951 4.29289 12.7076C4.10536 12.5201 4 12.2657 4 12.0005C4 11.7353 4.10536 11.4809 4.29289 11.2934C4.48043 11.1059 4.73478 11.0005 5 11.0005H12.17ZM9 17.0005C8.73478 17.0005 8.48043 17.1059 8.29289 17.2934C8.10536 17.4809 8 17.7353 8 18.0005C8 18.2657 8.10536 18.5201 8.29289 18.7076C8.48043 18.8951 8.73478 19.0005 9 19.0005C9.26522 19.0005 9.51957 18.8951 9.70711 18.7076C9.89464 18.5201 10 18.2657 10 18.0005C10 17.7353 9.89464 17.4809 9.70711 17.2934C9.51957 17.1059 9.26522 17.0005 9 17.0005ZM6.17 17.0005C6.3766 16.415 6.75974 15.9079 7.2666 15.5493C7.77346 15.1906 8.37909 14.998 9 14.998C9.62091 14.998 10.2265 15.1906 10.7334 15.5493C11.2403 15.9079 11.6234 16.415 11.83 17.0005H19C19.2652 17.0005 19.5196 17.1059 19.7071 17.2934C19.8946 17.4809 20 17.7353 20 18.0005C20 18.2657 19.8946 18.5201 19.7071 18.7076C19.5196 18.8951 19.2652 19.0005 19 19.0005H11.83C11.6234 19.586 11.2403 20.0931 10.7334 20.4517C10.2265 20.8104 9.62091 21.0029 9 21.0029C8.37909 21.0029 7.77346 20.8104 7.2666 20.4517C6.75974 20.0931 6.3766 19.586 6.17 19.0005H5C4.73478 19.0005 4.48043 18.8951 4.29289 18.7076C4.10536 18.5201 4 18.2657 4 18.0005C4 17.7353 4.10536 17.4809 4.29289 17.2934C4.48043 17.1059 4.73478 17.0005 5 17.0005H6.17Z"
        fill="#262626"
      />
    </svg>
  );
};

export const AboutGraph = () => {
  return (
    <svg
      fill="#666666"
      width="25px"
      height="25px"
      viewBox="0 -0.06 33.834 33.834"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <g transform="translate(-95.748 -577)">
          {' '}
          <path d="M110.965,592.309a2.38,2.38,0,0,1,.489-1.434,9.29,9.29,0,0,1,1.443-1.482,10.139,10.139,0,0,0,1.321-1.372,1.985,1.985,0,0,0,.368-1.2,1.956,1.956,0,0,0-1.983-2,2.073,2.073,0,0,0-1.419.543,3.575,3.575,0,0,0-.954,1.582l-2.152-.939a5.029,5.029,0,0,1,1.724-2.656,4.626,4.626,0,0,1,2.9-.927,4.968,4.968,0,0,1,2.287.531,4.168,4.168,0,0,1,1.651,1.495,3.974,3.974,0,0,1,.612,2.175,3.688,3.688,0,0,1-.538,1.965,8.8,8.8,0,0,1-1.639,1.865,13.862,13.862,0,0,0-1.358,1.322,1.536,1.536,0,0,0-.379,1,2.85,2.85,0,0,0,.1.667h-2.2A2.737,2.737,0,0,1,110.965,592.309Zm1.467,6.968a1.851,1.851,0,0,1-1.357-.543,1.831,1.831,0,0,1-.551-1.359,1.875,1.875,0,0,1,.551-1.372,1.835,1.835,0,0,1,1.357-.556,1.87,1.87,0,0,1,1.909,1.928,1.834,1.834,0,0,1-.55,1.359A1.857,1.857,0,0,1,112.432,599.277Z"></path>{' '}
          <path d="M97.222,610.717a1.475,1.475,0,0,1-.626-.14,1.459,1.459,0,0,1-.848-1.333V580.572A3.576,3.576,0,0,1,99.32,577h26.69a3.576,3.576,0,0,1,3.572,3.572v20.416a3.576,3.576,0,0,1-3.572,3.571H106.038a2.555,2.555,0,0,0-1.637.594l-6.24,5.22A1.467,1.467,0,0,1,97.222,610.717ZM99.32,579a1.574,1.574,0,0,0-1.572,1.572V608.11l5.37-4.491a4.561,4.561,0,0,1,2.92-1.06H126.01a1.573,1.573,0,0,0,1.572-1.571V580.572A1.574,1.574,0,0,0,126.01,579Z"></path>{' '}
        </g>{' '}
      </g>
    </svg>
  );
};

export const MenuIcon = () => {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="-0.5 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#666666"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M19 3.32001H16C14.8954 3.32001 14 4.21544 14 5.32001V8.32001C14 9.42458 14.8954 10.32 16 10.32H19C20.1046 10.32 21 9.42458 21 8.32001V5.32001C21 4.21544 20.1046 3.32001 19 3.32001Z"
          stroke="#666666"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
        <path
          d="M8 3.32001H5C3.89543 3.32001 3 4.21544 3 5.32001V8.32001C3 9.42458 3.89543 10.32 5 10.32H8C9.10457 10.32 10 9.42458 10 8.32001V5.32001C10 4.21544 9.10457 3.32001 8 3.32001Z"
          stroke="#666666"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
        <path
          d="M19 14.32H16C14.8954 14.32 14 15.2154 14 16.32V19.32C14 20.4246 14.8954 21.32 16 21.32H19C20.1046 21.32 21 20.4246 21 19.32V16.32C21 15.2154 20.1046 14.32 19 14.32Z"
          stroke="#666666"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
        <path
          d="M8 14.32H5C3.89543 14.32 3 15.2154 3 16.32V19.32C3 20.4246 3.89543 21.32 5 21.32H8C9.10457 21.32 10 20.4246 10 19.32V16.32C10 15.2154 9.10457 14.32 8 14.32Z"
          stroke="#666666"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{' '}
      </g>
    </svg>
  );
};
